import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';

@Component({
  selector: 'help',
  templateUrl: './help.component.html',
  styleUrls: ['./help.component.sass']
})
export class HelpComponent  {

  title: string = "Zapoznaj się z filmem instruktażowym naszej aplikacji";
  subtitle: string = " Zaprojektuj wygląd elewacji Twojego domu. Z aplikacją Knauf to proste jak nigdy wcześniej!";
  constructor(private location: Location) { }

  goBack() {
    this.location.back();
  }
}
